import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalVariableService } from './global-variable.service';
import { AppConfigService } from "./config.service";

@Injectable({
  providedIn: 'root'
})
export class AppService {
  private readonly apiUrl: string;
  private readonly fileUrl: string;

  constructor(
    private http: HttpClient,
    private globalVariable: GlobalVariableService,
    private configService: AppConfigService
  ) {
    this.apiUrl = this.configService.get('HOST_API_ONLINE');
    this.fileUrl = this.configService.get('FILE_URL');
  }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'Access-Control-Allow-Origin': '*',
      'Authorization': `Bearer ${this.globalVariable.getAccessToken()}`
    });
  }

  postData(url: string, data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}${url}`, data, { headers: this.getHeaders() });
  }

  updateData(url: string, data: any): Observable<any> {
    return this.http.put(`${this.apiUrl}${url}`, data, { headers: this.getHeaders() });
  }

  getData(url: string): Observable<any> {
    return this.http.get(`${this.apiUrl}${url}`, { headers: this.getHeaders() });
  }

  deleteData(url: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}${url}`, { headers: this.getHeaders() });
  }

  cancel(url: string): Observable<any> {
    return this.http.get(`${this.apiUrl}${url}`, { headers: this.getHeaders() });
  }

  getFicheInit(idCampagne: string): Observable<any> {
    return this.http.get(`${this.apiUrl}fiche/init/campagne/${idCampagne}`);
  }
}
